<template>
  <div :class="['bg_radial_lb', 'overflow-hidden']">
    <!-- 大容器 -->
    <div :class="['page_view', 'flex flex-col', 'lg:py-40 py-20']">
      <CommonBanner
        :title="t('page.index.news.fragment.title')"
        :desc="t('page.index.news.fragment.desc')"
        class="lg:mb-20 mb-10"
        theme="dark"
      />
      <!-- PC端卡片组-grid容器 -->
      <div :class="['hidden', 'lg:grid grid-cols-4 lg:gap-8', 'w-full h-140', 'mb-10']">
        <!-- 单个栅格 -->
        <Motion
          v-for="(item, index) in newsArticleSlice"
          :key="item.title"
          :initial="{ opacity: 0, y: 120 }"
          :while-in-view="{ opacity: 1, y: 0 }"
          :transition="{
            type: 'spring',
            stiffness: 20,
            damping: 10,
          }"
          :in-view-options="{
            once: true,
          }"
          :class="['hover:cursor-pointer', 'hover_elevated', cardStyle?.[index]?.class]"
        >
          <!-- 单卡片 -->
          <CommonFocusCard :model-value="item" />
        </Motion>
      </div>
      <!-- 窄屏下的新闻卡片组-轮播图，此处不用v-for循环 -->
      <UCarousel
        v-slot="{ item }"
        :items="newsArticleSlice"
        :dots="isMdWidth"
        drag-free
        :ui="{
          root: 'lg:mb-30 mb-15 lg:hidden block w-full',
          item: 'basis-60 lg:ps-10 ps-4',
          dots: '-mb-2',
        }"
      >
        <!-- 单卡片容器 -->
        <div class="h-60 w-full rounded-lg overflow-hidden">
          <CommonFocusCard :model-value="item" />
        </div>
      </UCarousel>

      <!-- 底部按钮容器 -->
      <div class="flex justify-center items-center">
        <CommonBtnPress
          :label="t('action.learnMore')"
          :type="2"
          tralling-icon="fe:arrow-right"
          @click="useLocalePush('/about/news')"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  const { t } = useI18n()
  const { isMdWidth } = useClientWidth()

  /** 卡片布局 */
  const cardStyle = [
    { class: 'col-span-2 row-span-2' },
    { class: 'col-span-2 col-start-3' },
    { class: 'col-start-3 row-start-2' },
    { class: 'col-start-4 row-start-2' },
  ]

  // 获取新闻类文章元数据列表
  const { getArticleListByStem } = useI18nContent()
  const newsArticleList = await getArticleListByStem()

  /** 仅取部分数据作为组件值 **/
  const newsArticleSlice = computed(() => newsArticleList.slice(0, 4))
</script>
